export default __webpack_public_path__ + "images/image6.3ebf2875.png";